<template>
  <v-container fluid>
    <v-form ref="validationForm">
      <v-row justify="center" class="mt-2 mx-5">
        <v-col>
          <h1 class="primary--text">Exclusão de Dependente</h1>
        </v-col>
        <v-col class="text-h5 primary--text mb-5" cols="12">
          <div>Preencha os campos abaixo para concluir a exclusão do Dependente</div>
        </v-col>

        <PlanInformation
          class="pb-0"
          :contractedPlanData="contractedPlanData"
          :isDetail="isFreeMovement ? false : true"
          :showHeaderPage="false"
          :showEligibility="false"
          :showStartValidityDate="false"
          :showEndValidityDate="false"
          :showCancellationReason="false"
          :showFamilyCode="false"
          :showFamilyCodeSequential="false"
          :loadingParent="loadingForm"
          @observerContractedPlan="observerContractedPlan"
        />

        <PrincipalInformations
          class="py-0"
          :holderInformationData="holderInformationData"
          :isFreeMovement="isFreeMovement"
          :isDetail="isFreeMovement ? false : true"
          :showHeaderPage="false"
          :showAdmissionDate="false"
          :showRegistrationPlate="true"
          :showCardNumber="true"
          @observerHolderInformationData="observerHolderInformationData"
        />

        <v-row class="mx-0 mt-0 pt-0">
          <v-col cols="12" xs="12" sm="12" md="3">
            <label class="label">Nome do Dependente</label>
            <v-text-field
              v-model.trim="dependent.name"
              class="mt-2"
              placeholder="Informe o nome do dependente"
              maxlength="70"
              outlined
              color="primary"
              :disabled="!isFreeMovement"
              :rules="dependent.name ? [rule.name, rule.validateIsAlphanumeric] : []"
              validate-on-blur
              @blur="dependent.name = formatter.formatToTitleCase(dependent.name)"
            />
          </v-col>
          <v-col cols="12" xs="12" sm="12" md="3">
            <label class="label">Nome social</label>
            <v-text-field
              v-model.trim="dependent.socialName"
              class="mt-2"
              placeholder="Informe o nome social"
              maxlength="70"
              outlined
              color="primary"
              :disabled="!isFreeMovement"
              :rules="dependent.socialName ? [rule.name, rule.validateIsAlphanumeric] : []"
              validate-on-blur
              @blur="dependent.socialName = formatter.formatToTitleCase(dependent.socialName)"
            />
          </v-col>
          <v-col cols="12" xs="12" sm="12" md="3">
            <label class="label">CPF do Dependente</label>
            <v-text-field
              v-model="dependent.document"
              class="mt-2"
              placeholder="Informe o número"
              v-mask="'###.###.###-##'"
              outlined
              color="primary"
              :disabled="!isFreeMovement"
              :rules="dependent.document ? [rule.cpf] : []"
              validate-on-blur
            />
          </v-col>
          <v-col cols="12" xs="12" sm="12" md="3">
            <label class="label">Código Familiar</label>
            <v-text-field
              outlined
              class="mt-2"
              v-model="familyCode"
              v-mask="`${ formatter.maskLimiter(10) }`"
              color="primary"
              placeholder="Informe  código familiar"
              :disabled="isDisabledFamilyCode"
            />
          </v-col>
          <v-col cols="12" xs="12" sm="12" md="3">
            <label class="label">Sequencial</label>
            <v-text-field
              outlined
              class="mt-2"
              v-model="familyCodeSequential"
              v-mask="`${ formatter.maskLimiter(5) }`"
              color="primary"
              placeholder="Informe código sequencial"
              :disabled="isDisabledFamilyCodeSequential"
            />
          </v-col>
          <v-col cols="12" xs="12" sm="12" md="3">
            <label class="label">Data Fim de Vigência</label>
            <v-menu
              v-model="validityDateMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              left
              min-width="auto">
              <template
                v-slot:activator="{ on, attrs }">
                <v-text-field
                  outlined
                  class="mt-2"
                  v-model="validityDate"
                  append-icon="fas fa-calendar-alt"
                  placeholder="dd/mm/aaaa"
                  v-mask="'##/##/####'"
                  color="primary"
                  validate-on-blur
                  v-bind="attrs"
                  v-on="on"
                  readonly
                  clearable
                  hide-details
                  @click="getAllowedDates()"
                  @click:clear="clearScheduledReleaseDate()"
                />
              </template>
              <AllowedDatePicker
                @date="updateValidityDate($event)"
                :allowedDates="allowedDates"
              />
            </v-menu>
            <div class="mb-5">
              <span  
                class="text-caption pl-3"  
                v-if="contractCutOfDate && contractCutOfDate > 0 && !isEdit">  
                Dia de corte: <b>{{ contractCutOfDate }}</b>  
              </span>
            </div>
          </v-col>
          <v-col
            v-if="shouldRenderMovementDeadlineField(
              scheduledReleaseDate,
              showScheduledReleaseDate,
              loadingScheduledReleaseDate
            )"
            :key="getMovementDeadlineFieldRenderKey(
              movementDeadlineConfig,
              scheduledReleaseDate,
              loadingScheduledReleaseDate,
              'dependent-delete-scheduled-release-col'
            )"
            cols="12"
            md="3">
            <label class="label">Data Agendada de Liberação</label>
            <v-tooltip
              :key="getMovementDeadlineFieldRenderKey(
                movementDeadlineConfig,
                scheduledReleaseDate,
                loadingScheduledReleaseDate,
                'dependent-delete-scheduled-release-tooltip'
              )"
              top>
              <template v-slot:activator="{ on, attrs }">
                <div v-bind="attrs" v-on="on">
                  <v-text-field
                      :key="getMovementDeadlineFieldRenderKey(
                        movementDeadlineConfig,
                        scheduledReleaseDate,
                        loadingScheduledReleaseDate,
                        'dependent-delete-scheduled-release'
                      )"
                      class='mt-2'
                      outlined
                      :value="scheduledReleaseDate"
                      color="primary"
                      readonly
                      append-icon="fas fa-calendar-alt"
                      :loading="loadingScheduledReleaseDate"
                    />
                </div>
              </template>
              <span>{{ getMovementDeadlineTooltip(validityDate, movementDeadlineConfig) }}</span>
            </v-tooltip>
          </v-col>
          <v-col cols="12" xs="12" sm="12" md="3">
            <label class="label">Motivo de Exclusão</label>
            <v-autocomplete
              v-model="exclusionReasonCode"
              :items="exclusionReasons"
              item-text="name"
              item-value="code"
              class="mt-2"
              placeholder="Selecione"
              outlined
              color="primary"
              clearable
            />
          </v-col>
        </v-row>
      </v-row>
      <div
        ref="uploadDocumentComponent"
        class="px-10"
        v-show="documentsVisibility">
        <div>
          <p class="title">Upload de Documentos</p>
        </div>

        <p
          class="text-h6 foreground--text">
          {{ beneficiaryData.contractName }}
        </p>

        <div
          class="px-2">
          <UploadDocuments
            ref="UploadDocuments"
            :showEditAndSaveButton="false"
            :showDownloadButton="isReuseMovement"
            :movementRecordId="movementRecord ? movementRecord.id : null"
            :updateParent="true"
            :movementType="'DELETE_DEPENDENT'"
            :beneficiaryType="'DEPENDENT'"
            :documentParams="documentParams"
            @observerDocumentData="documentsList = $event"
            @searchEnded="checkAllUploadDocuments"
            :startSearch="startSearch"
          />
        </div>
      </div>
    </v-form>

    <div v-if="violations.length > 0" class="mt-10">
      <ViolationRulesAlert :violations="violations" />
    </div>

    <div v-if="isCriticizedCarrier || isCriticizedBroker" style="position: absolute; z-index: 1;">
      <ViewCriticizedViolationDialog />
    </div>

    <v-dialog v-model="confirmReturnModal" persistent :max-width="600">
      <v-card class="overflow-y-auto pa-5">
        <v-card-title class="pa-5">
          <v-row justify="center">
            <v-col cols="12" align="center">
              <v-icon large color="success">fa-check</v-icon>
              <v-row class="mb-3" justify="center" style="word-break: break-word">
                <v-col cols="12" align="center">
                  <label class="label primary&#45;&#45;text font-italic" style="word-break: break-word">
                    Movimentação cadastrada com sucesso!
                  </label>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-title>
        <v-card-actions>
          <v-row class="ma-1 justify-center">
            <v-btn class="pa-7 foreground--text" color="primary" @click="closeConfirmReturnModal()">
              IR PARA A LISTA DE MOVIMENTAÇÕES
            </v-btn>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <ReleaseMovementModal
      ref="ReleaseMovementModal"
      @close="closeConfirmReturnModal()"
      @confirm="updateStatus()"
    />

    <TransitionMovementModal
      ref="TransitionMovementModal"
      @makeNewMovement="backToSeachHolderDependentDeletePage"
      @goToMovementList="goToMovementPage"
    />

    <InfoMovementDialog
      :show="showReleaseInfo" :movementType="movementType"
      :messageType="releaseMessageType"
      :beneficiaryName="dependent && dependent.name ? formatter.formatToTitleCase(dependent.name) : null"
      @close="closeConfirmReturnModal()"
    />

    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="120">
        <div>
          Carregando...
        </div>
      </v-progress-circular>
    </v-overlay>

    <v-footer>
      <v-row class="d-flex justify-end my-6 mt-15">
        <v-col cols="12" xs="12" sm="12" md="2" lg="2" class="pt-0">
          <v-btn
            v-if="!isEdit && !isCriticizedBroker && !isCriticizedCarrier"
            x-large
            block
            text
            color="primary"
            @click="onClickBack()"
          >
            Voltar
          </v-btn>
        </v-col>
        <v-btn
          class="mr-6"
          x-large
          outlined
          color="primary"
          width="250px"
          @click="onClickCancel()"
        >
          Cancelar
        </v-btn>
        <v-btn
          ref="buttonNext"
          class="foreground--text mr-10"
          x-large
          color="primary"
          width="250px"
          :loading="isLoadingSave"
          :disabled="waitingDocumentUpload"
          @click="openViewCriticismAndInternalNotesModal()"
        >
          Concluir
        </v-btn>
      </v-row>
    </v-footer>

    <SnackbarCustomize ref="SnackbarCustomize" />

    <ViewCriticismAndInternalNotesModal
      ref="ViewCriticismAndInternalNotesModal"
      @setSnackbarCustomize="setSnackbarCustomize()"
      @confirmCorrectionMovement="confirmCorrectionMovement"
    />

    <CriticismHandlingModal ref="CriticismHandlingModal" @confirm="openViewCriticismAndInternalNotesModal" />
  </v-container>
</template>

<script>
import lodash from 'lodash';
import CancelationReasonService from '@/services-http/odoo/CancelationReasonService';
import DocumentTypeService from '@/services-http/sdi/DocumentTypeService';
import DocumentService from '@/services-http/sdi/DocumentService';
import Formatters from '@/shared/formatters/formatters';
import Rules from '@/shared/validators/formRules';
import { store } from '@/shared/observable/store';
import ContractService from '@/services-http/contract/ContractService';
import PlanInformation from '@/components/Beneficiary/Contracted/PlanInformation.vue';
import MovementRecordService from '@/services-http/sdi/MovementRecordService';
import KinshipService from '@/services-http/contract/KinshipService';
import ViewCriticizedViolationDialog from '@/components/DynamicDialogInformation/ViewCriticizedViolationDialog.vue';
import PrincipalInformations from '@/components/Beneficiary/Holder/PrincipalInformations.vue';
import VerifyRoutesMixin from '@/shared/mixins/routeManagement/verifyRoutesMixin';
import ViolationRulesAlert from '@/components/CustomAlerts/ViolationRulesAlert.vue';
import InfoMovementDialog from '@/components/MovementDialog/InfoMovementDialog.vue';
import UserUtils from '@/shared/utils/user-utils';
import ReleaseMovementModal from '@/components/ReleaseMovement/ReleaseMovementModal.vue';
import ViewCriticismAndInternalNotesModal from '@/components/DashboardMovementRecords/Movements/Modals/ViewCriticismAndInternalNotes/ViewCriticismAndInternalNotesModal.vue';
import SnackbarCustomize from '@/components/CustomAlerts/SnackbarCustomize.vue';
import CriticismHandlingModal from '@/components/CustomAlerts/CriticismHandlingModal.vue';
import AllowedDatePicker from '@/components/AllowedDatePicker/AllowedDatePicker.vue';
import CarrierService from '@/services-http/contract/CarrierService';
import moment from 'moment';
import TransitionMovementModal from '@/components/TransitionMovementModal/TransitionMovementModal.vue';
import { mapGetters, mapMutations } from 'vuex';
import UploadDocuments from '@/components/Beneficiary/Documents/UploadDocuments.vue';
import AuthorityManagementMixin from '@/shared/mixins/authorityManagement/authorityManagementMixin';
import MovementRecordsMixin from '@/shared/mixins/movementRecords/movementRecordsMixin';
import ReuseMovementMixin from '@/shared/mixins/movementRecords/reuse/ReuseMovementMixin';

export default {
  name: 'BeneficiaryDelete',
  components: {
    InfoMovementDialog,
    ViolationRulesAlert,
    PrincipalInformations,
    PlanInformation,
    ViewCriticizedViolationDialog,
    ReleaseMovementModal,
    ViewCriticismAndInternalNotesModal,
    SnackbarCustomize,
    CriticismHandlingModal,
    AllowedDatePicker,
    TransitionMovementModal,
    UploadDocuments,
  },
  data: () => ({
    moment,
    validityDateMenu: null,
    validityDatePicker: null,
    carrierService: null,
    allowedDates: [],
    isRHProtegido: false,
    waitingDocumentUpload: false,
    overlay: false,
    isFreeMovement: false,
    isLoadingSave: false,
    isCriticizedCarrier: false,
    isCriticizedBroker: false,
    isDisabledFamilyCode: false,
    isDisabledFamilyCodeSequential: false,

    validityDate: null,
    planExtension: null,
    exclusionReasonCode: null,
    familyCode: null,
    familyCodeSequential: null,

    kinships: [],
    documentsList: [],
    documentsData: [],
    exclusionReasons: [],
    planExtensions: [
      { text: 'Sim', value: true },
      { text: 'Não', value: false },
    ],

    beneficiaryData: {},
    dependent: {
      document: '',
      name: '',
      socialName: '',
    },
    payload: {},
    uploadInformationDocuments: {},
    holderInformationData: {},
    contractedPlanData: {},
    confirmReturnModal: false,
    violations: [],
    hasAuthorityReleaseMovement: false,
    showReleaseInfo: false,
    movementType: 'Exclusão Dependente',
    successReleaseMessageType: 'RELEASE_SUCCESS',
    errorReleaseMessageType: 'RELEASE_ERROR',
    releaseMessageType: '',
    waitingRulesApprovalIds: [],
    formatDate: '',
    isEdit: false,
    internalCriticisms: [],
    persistWithCriticism: false,
    documentParams: {
      contractId: null,
      carrierId: null,
      hasGracePeriod: false,
      movementType: 'DELETE_DEPENDENT',
      beneficiaryType: 'DEPENDENT',
      kinshipId: null,
    },
    movementRecord: null,
    startSearch: false,
    documentsVisibility: false,
    contract: null,
    movementDeadlineConfig: null,
    showScheduledReleaseDate: false,
    scheduledReleaseDate: null,
    loadingScheduledReleaseDate: false,
    loadingForm: false,
    scheduledReleaseMovementType: 'exclusion',
    contractCutOfDate : null,
  }),

  async mounted() {
    this.loadingForm = true;
    await this.loadAuthorityMovement();
    await this.loadKinships();
    this.loadCancelationReasons();
    this.loadSessionStorage();
    await this.requestInsuranceCarrier();
    // await this.loadDocumentType();
    // await this.loadDocumentsByMovementRecordId();
    this.startSearch = true;
    this.validateShowScheduledReleaseDate();
    setTimeout(() => {
      this.loadingForm = false;
    }, 500);
  },

  mixins: [
    VerifyRoutesMixin,
    ReuseMovementMixin,
    AuthorityManagementMixin,
    MovementRecordsMixin,
  ],

  computed: {
    ...mapGetters({ searchParams: 'handler/searchParams' }),
    getObservableStore() {
      return store.dialogInformation;
    },
  },

  methods: {
    ...mapMutations({ setSearchParams: 'handler/setSearchParams' }),
    checkAllUploadDocuments() {
      const docComponentReference = this.$refs.UploadDocuments;

      this.documentsVisibility = docComponentReference
        && docComponentReference.documentsList.length > 0;

      this.startSearch = false;
    },
    setSessionStoreData() {
      if (sessionStorage.getItem('searchParams')) {
        this.setLayout(JSON.parse(sessionStorage.getItem('searchParams')));
        sessionStorage.removeItem('searchParams');
      }
    },
    async getAllowedDates() {
      const fullPath = this.$router.currentRoute.fullPath.toString();
      await this.carrierService.GetAllowedDates([parseInt(this.contractedPlanData.contractId)], 'DELETE_DEPENDENT').then((response) => {
        if (response.status === 200) {
          this.allowedDates = response.data;
        }
      });
    },
    async updateValidityDate(value) {
      this.validityDate = moment(value, 'YYYY-MM-DD').format('DD/MM/YYYY');
      this.validityDateMenu = false;
      await this.validateShowScheduledReleaseDate();
    },
    verifyFreeMovement() {
      if (this.$route.query.freeMovement && (this.$route.query.freeMovement === 'true' || this.$route.query.freeMovement === true)) {
        this.isFreeMovement = true;
      }
    },
    loadSessionStorage() {
      if (sessionStorage.getItem('beneficiaryData')) {
        this.beneficiaryData = JSON.parse(sessionStorage.getItem('beneficiaryData'));
        this.contractedPlanData = {
          financialGroupId: Number(this.beneficiaryData.financialGroupId),
          contractId: Number(this.beneficiaryData.contractId),
          subContractId: Number(this.beneficiaryData.subcontractId),
          planId: Number(this.beneficiaryData.planId),
          unitCode: this.beneficiaryData.unitCode,
          unitDescription: this.beneficiaryData.unitDescription,
          unitId: this.beneficiaryData.unitId,
        };

        this.dependent.name = this.formatter.formatToTitleCase(this.beneficiaryData.insuredName);
        this.dependent.socialName = this.beneficiaryData.socialInsuredName ? this.formatter.formatToTitleCase(this.beneficiaryData.socialInsuredName) : null;
        this.dependent.document = this.checkCPF(this.beneficiaryData.insuredCpf);
        this.familyCode = this.beneficiaryData.familyCode;
        this.familyCodeSequential = this.beneficiaryData.familyCodeSeq;
        this.isDisabledFamilyCode = this.familyCode !== null;
        this.isDisabledFamilyCodeSequential = this.familyCodeSequential !== null;

        const holderInformationData = {};
        holderInformationData.document = this.formatter.formatCpf(this.beneficiaryData.holderCpf);
        holderInformationData.name = this.formatter.formatToTitleCase(this.beneficiaryData.holderName);
        holderInformationData.socialName = this.beneficiaryData.socialHolderName ? this.formatter.formatToTitleCase(this.beneficiaryData.socialHolderName) : null;
        holderInformationData.registrationPlate = this.beneficiaryData.registrationPlate;
        holderInformationData.cardNumber = this.beneficiaryData.holderBeneficiaryCard;
        holderInformationData.financialGroupId = this.beneficiaryData.financialGroupId;
        holderInformationData.contractPlanId = this.beneficiaryData.parentContractPlanId;
        this.holderInformationData = holderInformationData;

        this.documentParams.contractId = this.beneficiaryData.contractId;
        this.documentParams.hasGracePeriod = !!this.beneficiaryData.hasGracePeriod;
        this.documentParams.kinshipId = this.beneficiaryData.kinshipId;
      }

      this.verifyTypeOperationForMovement();
      if (sessionStorage.getItem('movementRecord')) {
        this.mapBeneficiaryMovementRecord();
      }
    },
    verifyTypeOperationForMovement() {
      if (sessionStorage.getItem('isCriticizedBroker')) {
        this.isCriticizedBroker = true;
      }
      if (sessionStorage.getItem('isCriticizedCarrier')) {
        this.isCriticizedCarrier = true;
      }
      if (sessionStorage.getItem('isEdit')) {
        this.isEdit = true;
      }
    },
    async loadKinships() {
      await this.kinshipService.FindAll().then((response) => {
        if (response && response.data) {
          this.kinships = response.data.filter((kinship) => kinship.id !== 22
                              || kinship.code !== 'Titular'
                              || kinship.description !== 'Titular');
          this.kinships.sort((a, b) => (a.description > b.description ? 1 : -1));
        }
      });
    },
    checkCPF(cpf) {
      if (!cpf) {
        return '';
      }

      const validateCPF = String(cpf);

      if (validateCPF === '00000000000') {
        return '';
      }
      return this.formatter.formatCpf(validateCPF);
    },
    async mapBeneficiaryMovementRecord() {
      this.movementRecord = JSON.parse(sessionStorage.getItem('movementRecord'));
      if (this.movementRecord) {
        this.contractedPlanData = {
          financialGroupId: Number(this.movementRecord.financialGroupId),
          contractId: Number(this.movementRecord.contractId),
          subContractId: Number(this.movementRecord.subContractId),
          planId: Number(this.movementRecord.plan),
          unitId: this.movementRecord.unitId ? this.movementRecord.unitId : this.beneficiaryData.unitId,
          unitCode: this.movementRecord.unitCode ? this.movementRecord.unitCode : this.beneficiaryData.unitCode,
          unitDescription: this.movementRecord.unitDescription ? this.movementRecord.unitDescription : this.beneficiaryData.unitDescription,
        };

        this.dependent.name = this.movementRecord.insuredName ? this.formatter.formatToTitleCase(this.movementRecord.insuredName) : null;
        this.dependent.socialName = this.movementRecord.socialInsuredName ? this.formatter.formatToTitleCase(this.movementRecord.socialInsuredName) : null;
        this.dependent.document = this.checkCPF(this.movementRecord.insuredDocumentNumber);
        this.validityDate = this.movementRecord.endDate ? this.formatter.formatDate(this.movementRecord.endDate) : null;
        this.exclusionReasonCode = this.movementRecord.exclusionReasonCode;
        this.familyCode = this.movementRecord.familyCode;
        this.familyCodeSequential = this.movementRecord.familyCodeSequential;

        const holderInformationData = {};
        holderInformationData.document = this.movementRecord.holderDocumentNumber ? this.formatter.formatCpf(this.movementRecord.holderDocumentNumber) : null;
        holderInformationData.name = this.movementRecord.holderName ? this.movementRecord.holderName : null;
        holderInformationData.socialName = this.movementRecord.socialHolderName ? this.movementRecord.socialHolderName : null;
        holderInformationData.registrationPlate = this.movementRecord.registrationPlate ? this.movementRecord.registrationPlate : null;
        holderInformationData.cardNumber = this.movementRecord.beneficiaryCard;
        holderInformationData.contractPlanId = this.movementRecord.beneficiaryContractedPlanId;
        this.uploadInformationDocuments.insuranceCarrierId = this.movementRecord.insuranceCarrierId;
        this.holderInformationData = holderInformationData;

        this.isDisabledFamilyCode = this.familyCode !== null;
        this.isDisabledFamilyCodeSequential = this.familyCodeSequential !== null;

        this.documentParams.carrierId = this.movementRecord.insuranceCarrierId;
        this.documentParams.contractId = this.movementRecord.contractId;
        this.documentParams.hasGracePeriod = !!this.movementRecord.hasGracePeriod;
        this.documentParams.kinshipId = this.movementRecord.degreeKinship;
        this.documentParams.benefitTypeCode = this.movementRecord.benefitType;
      }
    },
    loadCancelationReasons() {
      const params = new URLSearchParams();
      params.append('refresh', 'false');
      params.append('beneficiaryTypeFilters', 'DEPENDENT');
      this.cancelationReasonService.FindAll('', params).then((response) => {
        if ((response && response.data) && (response.data.records && response.data.records.length > 0)) {
          this.exclusionReasons = response.data.records;
        }
        this.exclusionReasons.sort((a, b) => (a.name > b.name ? 1 : -1));
      });
    },
    async requestInsuranceCarrier() {
      if (!this.beneficiaryData.subcontractId) return;

      if (!this.isCriticizedCarrier && !this.isEdit) {
        this.overlay = true;
        this.contractCutOfDate = null; 
        await this.contractService.FindById(this.beneficiaryData.contractId).then(async (response) => {
          this.contract = response.data;
          this.movementDeadlineConfig = await this.getMovementDeadlineConfigByContractId(
            this.beneficiaryData.subcontractId,
            this.scheduledReleaseMovementType,
            this.contract.cut_off_date,
          );
          this.uploadInformationDocuments.insuranceCarrierId = await response.data.carrier_id.id;
          
          const cutOffDate = response.data.cut_off_date || null;  
  
          if (cutOffDate && cutOffDate > 0) {  
            this.contractCutOfDate = cutOffDate.toString();  
          }
          this.documentParams.carrierId = this.uploadInformationDocuments.insuranceCarrierId;
          this.overlay = false;
        }).catch(() => {
          this.overlay = false;
        });
      }
    },
    async loadDocumentType() {
      this.uploadInformationDocuments.movementType = 'DELETE_DEPENDENT';
      this.uploadInformationDocuments.beneficiaryType = 'DEPENDENT';
      const data = `movementType=${this.uploadInformationDocuments.movementType}&insuranceCarrierId=${this.uploadInformationDocuments.insuranceCarrierId}&beneficiaryType=${this.uploadInformationDocuments.beneficiaryType}`;
      await this.findDocumentType(data);
    },
    async findDocumentType(data) {
      await this.documentTypeService.FindAllDocumentType(data).then(async (response) => {
        this.documentsList = await response.data.content.map((element) => ({
          id: element.id,
          name: element.name,
          description: element.description,
          file: null,
        }));
      });
    },
    async uploadDocument(item) {
      if (item) {
        if ((item.file && !this.rule.isValidFileSize(item.file.size)) || (item.file && item.file.type && (item.file.type !== 'application/pdf' && item.file.type !== 'image/jpeg' && item.file.type !== 'image/png'))) {
          return;
        }
      }
      if (item.file !== null && typeof item.file !== 'undefined') {
        await this.clearDocument(item);
        const documentTypeId = item.documentTypeId ? item.documentTypeId : item.id;
        this.waitingDocumentUpload = true;
        this.disableButton = true;
        this.documentService.UploadDocument(documentTypeId, item.file).then((response) => {
          this.waitingDocumentUpload = false;
          this.documentsData.push({
            id: response.data,
            name: item.name,
            file: item.file,
            type: item.file.type,
          });
          // eslint-disable-next-line no-param-reassign
          item.idRecentlyUploaded = response.data;
        }).catch(() => {
          this.waitingDocumentUpload = false;
        });
      } else {
        await this.clearDocument(item);
      }
    },
    async clearDocument(item) {
      if (item) {
        if (this.documentsData && this.documentsData.length > 0) {
          const documentIndex = this.documentsData.findIndex((document) => document.documentTypeId === item.documentTypeId);
          if (documentIndex >= 0) {
            this.documentsData.splice(documentIndex, 1);
          }
        }
      }
    },
    openViewCriticismAndInternalNotesModal(isContinue) {
      this.persistWithCriticism = !!isContinue;
      if (this.isCriticizedCarrier) {
        const queryParams = {
          movementRecord: this.movementRecord,
          isRHProtegido: this.isRHProtegido,
          viewType: 'confirmCorrectionMovement',
        };

        this.$refs.ViewCriticismAndInternalNotesModal.open(queryParams);
      } else {
        this.onClickFinish();
      }
    },
    confirmCorrectionMovement(data) {
      this.internalCriticisms = data;
      this.$refs.ViewCriticismAndInternalNotesModal.close();
      this.onClickFinish();
    },
    async onClickFinish() {
      if (!this.$refs.UploadDocuments.validate()) return;

      if (this.$refs.validationForm.validate()) {
        await this.formatPayload();
        this.isLoadingSave = true;
        setTimeout(() => {
          if (this.isEdit || this.isCriticizedBroker) {
            this.updateDeleteMovementRecordService();
          } else {
            this.deleteMovementRecordService();
          }
        }, 500);
      } else {
        this.setSnackbarCustomize('error', 'Preencha os campos obrigatórios para prosseguir');
      }
    },
    async formatPayload() {
      this.formatDate = this.validityDate ? this.formatter.formatDateBRtoString(this.validityDate) : null;
      if (this.isEdit || this.isCriticizedBroker) {
        this.formatPayloadEditAndCriticizedBroker();
      } else {
        await this.formatPayloadCreateAndCriticizedCarrier();
      }

      if (this.isFreeMovement) {
        this.payload.holderRegistrationPlate = this.holderInformationData.registrationPlate ? this.holderInformationData.registrationPlate : null;
        this.payload.holderCardNumber = this.holderInformationData.cardNumber ? this.holderInformationData.cardNumber : null;
      }
    },
    async formatPayloadCreateAndCriticizedCarrier() {
      this.payload = {
        contract: this.contractedPlanData.contractId ? this.contractedPlanData.contractId : null,
        subcontract: this.contractedPlanData.subContractId ? this.contractedPlanData.subContractId : null,
        financialGroup: this.contractedPlanData.financialGroupId ? this.contractedPlanData.financialGroupId : null,
        plan: this.contractedPlanData.planId ? this.contractedPlanData.planId : null,
        dependents: [
          {
            cpf: this.dependent.document ? this.formatter.removeNonDigit(this.dependent.document) : null,
            name: this.dependent.name ? this.dependent.name : null,
            socialInsuredName: this.dependent.socialName ? this.dependent.socialName : null,
            dependentContractedPlanId: this.beneficiaryData.contractPlanId,
          },
        ],
        exclusionReasonCode: this.exclusionReasonCode ? this.exclusionReasonCode : null,
        endDate: this.formatDate,
        documents: this.documentFormatted(),
        deleteHolder: false,
        beneficiaryContractedPlanId: this.holderInformationData.contractPlanId ? this.holderInformationData.contractPlanId : null,
        holderCpf: this.holderInformationData.document ? this.formatter.removeNonDigit(this.holderInformationData.document) : null,
        holderName: this.holderInformationData.name ? this.holderInformationData.name : null,
        socialHolderName: this.holderInformationData.socialName ? this.holderInformationData.socialName : null,
        familyCode: this.familyCode,
        holderCardNumber: this.holderInformationData.cardNumber,
        familyCodeSequential: this.familyCodeSequential,
        holderRegistrationPlate: this.holderInformationData.registrationPlate,
      };

      if (this.isCriticizedCarrier) {
        this.payload.dependents[0].movementRecordParentId = this.movementRecord.id;
        this.payload.dependents[0].dependentContractedPlanId = this.movementRecord.dependentContractedPlanId;
        this.payload.internalCriticisms = this.internalCriticisms;
      }

      if (this.isReuseMovement) {
        const contractPlan = await this.fetchBeneficiaryContractedPlanByParams(
          this.movementRecord,
          this.contractedPlanData.contractId,
          this.contractedPlanData.subContractId,
        );

        this.payload.beneficiaryContractedPlanId = contractPlan.parentContractPlanId;
        this.payload.dependents[0].dependentContractedPlanId = contractPlan.contractPlanId;
      }
    },
    formatPayloadEditAndCriticizedBroker() {
      this.payload = {
        contractId: this.contractedPlanData.contractId ? this.contractedPlanData.contractId : null,
        subContractId: this.contractedPlanData.subContractId ? this.contractedPlanData.subContractId : null,
        financialGroupId: this.contractedPlanData.financialGroupId ? this.contractedPlanData.financialGroupId : null,
        planId: this.contractedPlanData.planId ? this.contractedPlanData.planId : null,
        exclusionReasonCode: this.exclusionReasonCode ? this.exclusionReasonCode : null,
        endDate: this.formatDate,
        dependentName: this.dependent.name ? this.dependent.name : null,
        socialInsuredName: this.dependent.socialName ? this.dependent.socialName : null,
        dependentCpf: this.dependent.document ? this.formatter.removeNonDigit(this.dependent.document) : null,
        beneficiaryContractedPlanId: this.holderInformationData.contractPlanId ? this.holderInformationData.contractPlanId : null,
        holderName: this.holderInformationData.name ? this.holderInformationData.name : null,
        socialHolderName: this.holderInformationData.socialName ? this.holderInformationData.socialName : null,
        holderCpf: this.holderInformationData.document ? this.formatter.removeNonDigit(this.holderInformationData.document) : null,
        familyCode: this.familyCode,
        familyCodeSequential: this.familyCodeSequential,
        holderRegistrationPlate: this.holderInformationData.registrationPlate,
        documents: this.documentFormatted(),
      };
    },
    async deleteMovementRecordService() {
      let criticsm = [];

      if (sessionStorage.getItem('criticismRules')) {
        criticsm = JSON.parse(sessionStorage.getItem('criticismRules')).filter((movement) => movement.classification && movement.classification === 'INTERNAL').map((movement) => movement.id);
      }

      this.payload = lodash.cloneDeep({
        ...this.payload,
        internalCriticisms: criticsm,
        persistWithCriticism: this.persistWithCriticism ? this.persistWithCriticism : false,
        holderRegistrationPlate: this.holderInformationData.registrationPlate,
      });

      await this.processMovementRecordService(this.movementRecordService.Delete, this.payload, this.isFreeMovement);
    },
    async updateDeleteMovementRecordService() {
      this.payload = {
        ...this.payload,
        persistWithCriticism: this.persistWithCriticism ? this.persistWithCriticism : false,
        holderRegistrationPlate: this.holderInformationData.registrationPlate,
      };
      await this.processMovementRecordService(this.movementRecordService.UpdateDeleteDependentMovementRecordById, this.movementRecord.id, this.payload, this.isFreeMovement, this.isCriticizedBroker);
    },
    async processMovementRecordService(serviceMethod, ...args) {
      this.violations = [];
      this.overlay = true;

      this.movementRecordService = this.formatter.validateEmptyValues(this.movementRecordService);

      try {
        const response = await serviceMethod.call(this.movementRecordService, ...args);
        const { recordList } = response.data;
        const allWithStatusWaitingRulesApproval = recordList.every((movement) => movement.status === 'WAITING_APPROVAL_RULES_VALIDATIONS');

        this.waitingRulesApprovalIds = recordList.filter((movement) => movement.status === 'WAITING_APPROVAL_RULES_VALIDATIONS').map((movement) => movement.id);

        if (allWithStatusWaitingRulesApproval) {
          const releaseMovementData = {
            beneficiaryName: this.dependent.name,
            movementType: this.movementType,
          };

          this.$refs.ReleaseMovementModal.open(releaseMovementData);
        } else {
          await this.updateStatus();
        }
      } catch (error) {
        this.overlay = false;
        this.isLoadingSave = false;
        this.documentsData = [];
        if (error.response && error.response.status === 422) {
          this.violations = [...error.response.data.violations];

          if (!this.areAllowedToCriticize()) return;

          this.$refs.CriticismHandlingModal.open();
        }
      }
    },
    areAllowedToCriticize() {
      if (!this.hasPermission('sdi_mov_prosseguir_critica') && this.violations && this.violations.length > 0) {
        this.setSnackbarCustomize('error', 'Erro de validação de regras no preenchimento do formulário');
        return false;
      }

      return true;
    },
    observerContractedPlan(data) {
      this.contractedPlanData = data;

      this.documentParams.contractId = this.contractedPlanData.contractId;
      this.documentParams.hasGracePeriod = !!this.contractedPlanData.hasGracePeriod;

      if (this.isReuseMovement) {
        this.documentParams.carrierId = this.contractedPlanData.carrierId;
      }

      setTimeout(() => {
        this.startSearch = true;
      }, 500);
    },
    observerHolderInformationData(data) {
      this.holderInformationData = data;
    },
    onClickBack() {
      if (this.isReuseMovement) {
        this.goToMovementPage();
        return;
      }
      this.redirectRouter('ManualMovementDeleteSearch', { isRHProtegido: this.isRHProtegido });
    },
    onClickCancel() {
      let routeName = '';
      if (this.isEdit || this.isCriticizedBroker || this.isCriticizedCarrier || this.isReuseMovement) {
        routeName = 'Movement';
      } else {
        routeName = this.isRHProtegido ? 'HomeRHProtegido' : 'Movement';
      }

      this.redirectRouter(routeName, { isRHProtegido: this.isRHProtegido });
    },
    async loadDocumentsByMovementRecordId() {
      if (this.movementRecord && this.movementRecord.id) {
        const queryString = `?movementRecordId=${this.movementRecord.id}`;
        await this.documentService.FindDocumentByFilters(queryString).then(async (response) => {
          if (response && response.data && response.data.length > 0) {
            if (this.documentsList && this.documentsList.length > 0) {
              await new Promise((resolve) => {
                resolve(this.documentsList.forEach(async (documentList) => {
                  await response.data.forEach((document) => {
                    if (documentList.name === document.documentType.name) {
                    // eslint-disable-next-line no-param-reassign
                      documentList.file = new File([document.name], document.name, { type: 'image/png' });
                      // eslint-disable-next-line no-param-reassign
                      documentList.documentTypeId = document.documentType.id;
                      // eslint-disable-next-line no-param-reassign
                      documentList.id = document.id;
                      // eslint-disable-next-line no-param-reassign
                      documentList.name = document.name;
                      // eslint-disable-next-line no-param-reassign
                      documentList.loadingDownload = false;
                    }
                  });
                }));
              });
            }
          }
          await this.loadDocumentsInData();
        });
      }
    },
    async loadDocumentsInData() {
      this.documentsList.forEach((document) => {
        if (document && document.documentTypeId) {
          this.documentsData.push(document);
        }
      });
    },
    documentFormatted() {
      const documentFormatted = this.documentsList.filter((element) => element.file !== null && typeof element.file !== 'undefined').map((element) => ({ id: element.idRecentlyUploaded ? element.idRecentlyUploaded : element.id }));
      return documentFormatted;
    },
    closeConfirmReturnModal() {
      this.$refs.ReleaseMovementModal.close();

      if (!this.isEdit && !this.isCriticizedBroker && !this.isCriticizedCarrier && !this.isReuseMovement) {
        const releaseMovementData = {
          beneficiaryName: this.dependent.name,
          movementType: this.movementType,
        };

        this.$refs.TransitionMovementModal.open(releaseMovementData);
      } else {
        this.goToMovementPage();
      }
    },
    backToSeachHolderDependentDeletePage() {
      this.$refs.TransitionMovementModal.close();
      this.redirectRouter('ManualMovementDeleteSearch', { isRHProtegido: this.isRHProtegido }, { creation: true });
    },
    goToMovementPage() {
      this.redirectRouter('Movement', { isRHProtegido: this.isRHProtegido }, { movement: 'movement' });
      this.confirmReturnModal = false;
      this.overlay = false;
      this.documentsData = [];
    },
    async loadAuthorityMovement() {
      this.hasAuthorityReleaseMovement = this.userUtils.hasAuthorityToAccess({ authority: 'sdi_painel_movimentacoes_cadastrais_liberar_movimentacao' });
    },
    async updateStatus() {
      const movementRecordService = new MovementRecordService();
      this.$refs.ReleaseMovementModal.close();

      if (this.hasAuthorityReleaseMovement && this.waitingRulesApprovalIds.length > 0) {
        const request = {
          ids: [...this.waitingRulesApprovalIds],
          status: 'VALID',
        };

        await movementRecordService.UpdateStatusFromMultipleMovements(request).then(() => {
          this.releaseMessageType = this.successReleaseMessageType;
          this.closeConfirmReturnModal();
          this.setSnackbarCustomize('success', 'Movimentação liberada com sucesso');
        }).catch(() => {
          this.releaseMessageType = this.errorReleaseMessageType;
          this.closeConfirmReturnModal();
          this.setSnackbarCustomize('error', 'Ocorreu um erro ao liberar a movimentação');
        });
      } else {
        this.releaseMessageType = this.errorReleaseMessageType;
        this.closeConfirmReturnModal();
        this.setSnackbarCustomize('error', 'Você não tem permissão para liberar a movimentação');
      }
    },
    async downloadDocuments(item) {
      if (item && item.file !== null) {
        // eslint-disable-next-line no-param-reassign
        item.loadingDownload = true;
        this.$forceUpdate();
        const id = item.idRecentlyUploaded ? item.idRecentlyUploaded : item.id;
        const queryString = `?idDocuments=${id}`;

        await this.documentService.DownloadFileDocuments(queryString).then((response) => {
          if (response) {
            const fileURL = window.URL.createObjectURL(new Blob([response.data]));
            const fileLink = document.createElement('a');
            const contentDispositionHeader = response.headers['content-disposition'];
            const name = this.validateNameInResponseHeaders(contentDispositionHeader);
            const nameDecoded = decodeURIComponent(name);
            fileLink.href = fileURL;
            fileLink.setAttribute('download', nameDecoded);
            document.body.appendChild(fileLink);
            fileLink.click();

            this.selectedItems = [];
            // eslint-disable-next-line no-param-reassign
            item.loadingDownload = false;
            this.$forceUpdate();
          }
        }).catch(() => {
          // eslint-disable-next-line no-param-reassign
          item.loadingDownload = false;
          this.$forceUpdate();
        }).finally(() => {
          // eslint-disable-next-line no-param-reassign
          item.loadingDownload = false;
          this.$forceUpdate();
        });
      }
    },
    validateNameInResponseHeaders(contentDispositionHeader) {
      const fileNameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
      const matches = fileNameRegex.exec(contentDispositionHeader);
      let fileName = null;
      if (matches && matches[1]) {
        fileName = matches[1].replace(/['"]/g, '');
      }

      let name;
      if (fileName) {
        name = fileName;
      } else if (this.selectedItems.length === 1) {
        const firstSelectedDocumentId = this.selectedItems[0].id;
        const matchingDocument = this.documents.find((element) => element.id === firstSelectedDocumentId);
        name = matchingDocument ? matchingDocument.name : null;
      } else {
        name = 'filename.zip';
      }

      return name;
    },
    truncateText(text, maxLength) {
      if (text && text.length > maxLength) {
        return `${text.slice(0, maxLength)}...`;
      }
      return text;
    },
    setSnackbarCustomize(type, message) {
      this.$refs.SnackbarCustomize.open(type, message);
    },
    async validateShowScheduledReleaseDate() {
      if (!this.contract || this.contract && !this.contract.id) {
        this.movementDeadlineConfig = null;
        this.showScheduledReleaseDate = false;
        this.scheduledReleaseDate = null;
        this.changeLoadingSheduledReleaseDate(false);
        await this.syncMovementDeadlineView();
        return;
      }
      this.showScheduledReleaseDate = this.shouldShowMovementDeadlineField(
        this.validityDate,
        this.movementDeadlineConfig,
      );
      this.scheduledReleaseDate = null;
      this.changeLoadingSheduledReleaseDate(this.showScheduledReleaseDate);
      await this.syncMovementDeadlineView();

      if (this.showScheduledReleaseDate && this.validityDate) {
        try {
          const result = await this.getCalculateScheduledDate(
            this.validityDate,
            this.contractedPlanData.subContractId,
            this.scheduledReleaseMovementType,
          );
          this.scheduledReleaseDate = result || '-';
          await this.syncMovementDeadlineView();
        } catch (error) {
          this.$refs.SnackbarCustomize.open('error', 'Ocorreu um erro na busca pela data agendada');
        } finally {
          this.changeLoadingSheduledReleaseDate(false);
          await this.syncMovementDeadlineView();
        }
      }
    },
    async clearScheduledReleaseDate() {
      this.showScheduledReleaseDate = this.shouldShowMovementDeadlineField(
        this.validityDate,
        this.movementDeadlineConfig,
      );
      this.scheduledReleaseDate = null;
      this.changeLoadingSheduledReleaseDate(false);
      await this.syncMovementDeadlineView();
    },
    changeLoadingSheduledReleaseDate(value = null) {
      this.loadingScheduledReleaseDate = typeof value === 'boolean'
        ? value
        : !this.loadingScheduledReleaseDate;
    },
  },

  created() {
    this.verifyFreeMovement();
    this.cancelationReasonService = new CancelationReasonService();
    this.documentTypeService = new DocumentTypeService();
    this.documentService = new DocumentService();
    this.formatter = new Formatters();
    this.rule = new Rules();
    this.contractService = new ContractService();
    this.movementRecordService = new MovementRecordService();
    this.kinshipService = new KinshipService();
    this.userUtils = new UserUtils();
    this.carrierService = new CarrierService();
  },
};
</script>
